export default __webpack_public_path__ + "static/media/image4.bfda3624.jpg";